import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import quote from '../../../content/media-library/quote.svg';
import quoteTeal from '../../../content/media-library/quote-teal.svg';

const CampaignQuote = (props) => {
  const { title, subTitle, colourScheme, customPadding } = props;

  const componentClasses = classNames('campaign-quote', {
    [` campaign-quote--${colourScheme}`]: colourScheme,
    'campaign-quote--no-padding-top': customPadding === 'no-top',
    'campaign-quote--no-padding-bottom': customPadding === 'no-bottom',
    'campaign-quote--no-padding-top-bottom': customPadding === 'no-padding'
  });

  return (
    <div className={componentClasses}>
      {title ? <h2 className="campaign-quote__title">{title}</h2> : ''}
      {subTitle ? <p className="campaign-quote__subtitle">{subTitle}</p> : ''}
      <blockquote className="campaign-quote__blockquote">
        <h2 className="has-lines">
          <img src={colourScheme === 'dark-navy' ? quoteTeal : quote} alt="quotes" />
        </h2>
        <div dangerouslySetInnerHTML={{ __html: props[props.src] }} />
      </blockquote>
    </div>
  );
};

CampaignQuote.propTypes = {
  src: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  colourScheme: PropTypes.oneOf(['dark-navy', 'light-grey']),
  customPadding: PropTypes.oneOf(['no-top', 'no-bottom', 'no-padding'])
};

export default CampaignQuote;
